import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card, Typography, Box } from '@mui/material';
import { FadeLoader } from 'react-spinners';
import Page from '../../components/Page';
import FuneralFormSection from '../../sections/@dashboard/funerals/FuneralFormSection';
import tracker from '../../api/tracker';

const override = { margin: '0 auto' };

export default function FuneralEdit() {
  const { hashid } = useParams();
  const [funeralForm, setFuneralForm] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await tracker.get(`funerals/${hashid}`);
      setFuneralForm(response.data.data);
      setLoading(false);
    })();
  }, [hashid]);

  return (
    <Page title="Edit Funeral">
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          {funeralForm?.deceased_name || 'Edit Funeral'}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
            <FadeLoader cssOverride={override} color="#032C65" />
          </Box>
        ) : (
          <Card sx={{ p: 3 }}>
            <FuneralFormSection funeralForm={funeralForm} />
          </Card>
        )}
      </Container>
    </Page>
  );
}
